import { Field } from "redux-form";

import { capitalize } from "@braintrust/braintrust-ui-components";
import { TextField } from "@js/forms/fields/text";

type Variant = "first_name" | "last_name";

export const FirstOrLastNameField = ({
  variant,
  autoFocus,
  prefixWithLegal,
}: {
  variant: Variant;
  autoFocus?: boolean;
  prefixWithLegal?: boolean;
}) => {
  const baseLabel = variant.replace("_", " ");
  const label = prefixWithLegal ? `Legal ${baseLabel}` : capitalize(baseLabel);
  const placeholder = `Enter your ${baseLabel}`;
  return (
    <Field
      name={variant}
      placeholder={placeholder}
      maxLength={50}
      variant="outlined"
      color="secondary"
      id={variant.replace("_", "-")}
      component={TextField}
      label={`${label}*`}
      autoFocus={autoFocus}
    />
  );
};
